export default "__VITE_ASSET__1cc5623e__"